import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=cefb2bec&scoped=true&"
import script from "./ProductsDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=cefb2bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefb2bec",
  null
  
)

export default component.exports